import { CustomerSupportRequestStatus } from "../enums";

export class SupportRequestSearchFilter {
    ticketId: string;
    trackingNumber: string;
    country: string;
    raisedby: string;
    categoryId: number;
    customerId: number;
    isSearch: boolean;
    status: any;
    franchiseId: number;
    warehouseId: string;
}